import type { ReactNode } from 'react';

export const symbol_join_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M121.5-678.5Q203-760 320-760q26 0 50.5 5t47.5 13q12 5 14 18t-8 22q-45 44-69.5 101.5T330-480q0 63 24.5 120.5T424-258q10 10 8 22.5T418-218q-23 8-47.5 13t-50.5 5q-117 0-198.5-81.5T40-480q0-117 81.5-198.5Zm349 418Q466-262 461-266q-48-41-74.5-95.5T360-480q0-64 26.5-118.5T461-694q5-4 9.5-5.5t9.5-1.5q5 0 9.5 1.5t9.5 5.5q48 41 74.5 95.5T600-480q0 64-26.5 118.5T499-266q-5 4-9.5 5.5T480-259q-5 0-9.5-1.5ZM899-373q-21 51-61 91-54 54-128 73.5T562-211q-12-4-18-14.5t-2-22.5q4-12 14.5-18t22.5-2q58 17 116 1.5T796-325q31-31 47.5-71t16.5-84q0-44-16.5-84.5T796-636q-43-43-101-58t-116 2q-12 4-22.5-2T542-712q-4-12 2-22.5t18-14.5q74-22 148-2.5T838-678q40 40 61 91t21 107q0 56-21 107Z"
		/>
	</svg>
);
